import { render, staticRenderFns } from "./UnsignedChip.vue?vue&type=template&id=a4edafe2&scoped=true"
import script from "./UnsignedChip.vue?vue&type=script&lang=js"
export * from "./UnsignedChip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4edafe2",
  null
  
)

export default component.exports